import React, {Component} from 'react';
import {BackButton} from '../../components/BackButton/BackButton';

import './TermsConditions.css';

export class TermsConditions extends Component {
  constructor(props) {
    super(props);

    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="Regular-page ui stackable center aligned padded column grid">
        <div className="one wide column">
        </div>

        <div className="ten wide column center aligned">

          <BackButton onClick={this.handleBackButtonClick}/>

          <div>
            &nbsp;
          </div>

          <div>
            <p>
              Terms and Conditions<br/>
              Last Updated: April 27, 2018
            </p>
          </div>

          <div>
            &nbsp;
          </div>

          <div className="left-aligned">
            
            Error!
            
          </div>

        </div>

        <div className="one wide column">
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TermsConditions/TermsConditions.js